document.addEventListener("DOMContentLoaded", function () {
  // 全局标记：是否已经初始化完成
  let initialized = false;
  // 全局尺寸最大值（统一数据源）
  let maxNumber = 0;

  // 配件匹配产品选项
  const bcpoMonitor = new MutationObserver((mutations) => {
    const bcpoElement = document.querySelector("#bcpo");
    if (bcpoElement) {
      const variantList = bcpoElement.querySelectorAll(
        ".bcpo-buttons .single-option-selector div",
      );

      // ===== 新增：监听主产品下拉框选择 =====
      function bindMainProductSelect() {
        const mainSelect = document.querySelector(
          ".main-product-item .accessories-options-list",
        );
        if (!mainSelect) return;

        mainSelect.addEventListener("change", function () {
          const selectedText =
            this.selectedOptions[0]?.textContent.trim() || "";
          // 提取所有数字
          const nums = selectedText.match(/\d+/g)?.map(Number) || [];
          maxNumber = nums.length ? Math.max(...nums) : 0;

          accessoriesChange();
          initialized = true; // 用户手动选择，开启校验
          document
            .querySelectorAll(".accessories-options-list")
            .forEach((select) => {
              validateRange(select);
            });
        });
      }
      bindMainProductSelect();

      // 输入框变化
      const inchInputs = document.querySelectorAll(".inch-input");
      function updateMaxNumberFromInputs() {
        const values = Array.from(inchInputs).map((input) => {
          return parseFloat(input.value.trim()) || 0;
        });
        maxNumber = values.length ? Math.max(...values) : 0;
        accessoriesChange();

        // 用户操作了 → 开启校验
        initialized = true;

        document
          .querySelectorAll(".accessories-options-list")
          .forEach((select) => {
            validateRange(select);
          });
      }
      inchInputs.forEach((input) => {
        input.addEventListener("input", updateMaxNumberFromInputs);
      });

      // 点击尺寸
      variantList.forEach((item) => {
        item.addEventListener("click", () => {
          const label = item.querySelector("label");
          const labelText = label ? label.textContent.trim() : "";

          const bcpoValueEl = document.querySelector(
            ".bcpo-auto-images .bcpo-value",
          );
          const bcpoValueText = bcpoValueEl
            ? bcpoValueEl.textContent.trim()
            : "";

          const nums = labelText.match(/\d+/g)?.map(Number) || [];
          maxNumber = nums.length ? Math.max(...nums) : null;

          const mainSelect = document.querySelector(
            ".main-product-item .accessories-options-list",
          );
          if (mainSelect && labelText && bcpoValueText) {
            const mainOptions = mainSelect.querySelectorAll("option");
            mainOptions.forEach((opt) => {
              const optText = opt.textContent.trim();
              const hasBcpoValue = optText.includes(bcpoValueText);
              const hasLabelText = optText.includes(labelText);
              if (hasBcpoValue && hasLabelText) {
                opt.selected = true;
                mainSelect.dispatchEvent(new Event("change"));
              }
            });
          }

          accessoriesChange();

          // 用户点击了 → 开启校验
          initialized = true;

          document
            .querySelectorAll(".accessories-options-list")
            .forEach((select) => {
              validateRange(select);
            });
        });
      });

      function accessoriesChange() {
        const allContainers = document.querySelectorAll(
          ".product-accessories-item",
        );
        allContainers.forEach((container) => {
          const selectEl = container.querySelector(".accessories-options-list");
          if (!selectEl) return;

          const options = Array.from(
            selectEl.querySelectorAll(".size-variant"),
          );

          // 1. 先尝试匹配范围内的选项
          const matchedOption = options.find((opt) => {
            const range = opt.dataset.rang;
            if (!range) return false;
            const [min, max] = range.split("-").map(Number);
            return maxNumber >= min && maxNumber <= max;
          });

          if (matchedOption) {
            matchedOption.selected = true;
            selectEl.dispatchEvent(new Event("change"));
          } else {
            // 2. 如果没有匹配（maxNumber超出所有范围），选择范围最大的选项
            let maxRangeOption = null;
            let maxRangeValue = -Infinity;

            options.forEach((opt) => {
              const range = opt.dataset.rang;
              if (!range) return;
              const [, max] = range.split("-").map(Number);
              // 比较最大值，找到范围最大的选项
              if (max > maxRangeValue) {
                maxRangeValue = max;
                maxRangeOption = opt;
              }
            });

            if (maxRangeOption) {
              maxRangeOption.selected = true;
              selectEl.dispatchEvent(new Event("change"));
            }
          }
        });
      }

      // ========== 核心校验 ==========
      function validateRange(select) {
        const item = select.closest(".product-accessories-item");
        if (!item) return;

        const selectedOption = select.selectedOptions[0];
        const errorEl = item.querySelector(".error-prompt");

        if (!selectedOption || !errorEl) return;

        // 初始化阶段：一律不显示错误
        if (!initialized) {
          errorEl.classList.remove("active");
          return;
        }

        // 主产品尺寸未知时不提示（如选择了 Customize 变体、定制选项尚未加载/未填写）
        if (!maxNumber || maxNumber <= 0) {
          errorEl.classList.remove("active");
          return;
        }

        // 只有用户操作后 initialized = true 才走校验
        const range = selectedOption.dataset.rang;
        let inRange = false;

        if (range && maxNumber > 0) {
          const [min, max] = range.split("-").map(Number);
          inRange = maxNumber >= min && maxNumber <= max;
        }

        if (inRange) {
          errorEl.classList.remove("active");
        } else {
          errorEl.classList.add("active");
        }
      }

      function accessoriesSelect() {
        document
          .querySelectorAll(".accessories-options-list")
          .forEach((select) => {
            select.addEventListener("change", function () {
              const selectedOption = this.selectedOptions[0];
              if (!selectedOption) return;

              const variantId = selectedOption.dataset.id;
              const price = selectedOption.dataset.price;
              const item = this.closest(".product-accessories-item");
              if (!item) return;

              item.setAttribute("buy-id", variantId);

              const priceEl = item.querySelector(".accessories-item-price");
              if (priceEl) priceEl.textContent = price;

              validateRange(this);
            });

            // 页面加载自动触发，但此时 initialized 还是 false，不会报错
            select.dispatchEvent(new Event("change"));
          });
      }

      function accessoriesCheckbox() {
        document
          .querySelectorAll(".accessories-item-checkbox")
          .forEach((box) => {
            box.addEventListener("click", () => {
              const item = box.closest(".product-accessories-item");
              box.classList.toggle("active");
              item.classList.toggle("active");
              calcTotalPriceAndMergeIds();
            });
          });

        document
          .querySelectorAll(".accessories-options-list")
          .forEach((select) => {
            function update() {
              const item = select.closest(".product-accessories-item");
              const option = select.selectedOptions[0];
              if (!option || !item) return;

              const variantId = option.dataset.id;
              const price = option.dataset.price;

              item.setAttribute("buy-id", variantId);

              const priceEl = item.querySelector(".accessories-item-price");
              if (priceEl) {
                priceEl.textContent = price;
              }

              calcTotalPriceAndMergeIds();
              validateRange(select);
            }

            select.addEventListener("change", update);
            update();
          });

        function calcTotalPriceAndMergeIds() {
          const items = document.querySelectorAll(
            ".product-accessories-item.active",
          );
          let total = 0;
          const ids = [];

          items.forEach((el) => {
            const priceText =
              el.querySelector(".accessories-item-price")?.textContent || "";
            const num = parseFloat(priceText.replace(/\$/g, "")) || 0;
            total += num;

            const bid = el.getAttribute("buy-id");
            if (bid) ids.push(bid);
          });

          const totalEl = document.querySelector(".accessories-total-price");
          if (totalEl) {
            totalEl.textContent = "$" + total.toFixed(2);
          }

          const btn = document.querySelector(".accessories-btn");
          if (btn) {
            btn.setAttribute("data-variant-id", ids.join(","));
          }

          const countEl = document.querySelector(".total-num-value");
          if (countEl) {
            countEl.textContent = items.length;
          }
        }
      }

      accessoriesSelect();
      accessoriesCheckbox();

      bcpoMonitor.disconnect();
    }
  });

  bcpoMonitor.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });



  // 弹窗显示隐藏切换
  document.addEventListener('click', function (e) {
    // 打开弹窗逻辑：点击 acc-window‑click
    const clickEl = e.target.closest('.acc-window-click');
    if (clickEl) {
      const itemEl = clickEl.closest('.product-accessories-item');
      if (!itemEl) return;
      const targetIndex = itemEl.getAttribute('index');

      // 全部弹窗移除active
      document.querySelectorAll('.product-acc-window').forEach(win => {
        win.classList.remove('active');
      });

      const targetWindow = document.querySelector(`.product-acc-window[index="${targetIndex}"]`);
      if (targetWindow) {
        targetWindow.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    // 关闭弹窗逻辑：点击遮罩acc-window‑mask / 关闭按钮acc-window‑btn
    const closeEl = e.target.closest('.acc-window-mask, .acc-window-btn');
    if (closeEl) {
      document.querySelectorAll('.product-acc-window').forEach(win => {
        win.classList.remove('active');
      });
      // 恢复页面滚动
      document.body.style.overflow = '';
    }
  });


  // 弹窗缩略图切换
  var thumbItems = document.querySelectorAll('.acc-thumbs-img-item');

  thumbItems.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var imgBox = thumb.closest('.acc-window-img-box');
      if (!imgBox) return;

      var mainImgItems = imgBox.querySelectorAll('.acc-main-img-item');
      var thumbItemsInBox = imgBox.querySelectorAll('.acc-thumbs-img-item');
      var index = Array.from(thumbItemsInBox).indexOf(thumb);

      mainImgItems.forEach(function (item) {
        item.classList.remove('active');
      });
      thumbItemsInBox.forEach(function (item) {
        item.classList.remove('active');
      });

      thumb.classList.add('active');
      if (mainImgItems[index]) {
        mainImgItems[index].classList.add('active');
      }
    });
  });

  // 默认每组第一张显示
  document.querySelectorAll('.acc-window-img-box').forEach(function (box) {
    var firstThumb = box.querySelector('.acc-thumbs-img-item');
    var firstMain = box.querySelector('.acc-main-img-item');
    if (firstThumb) firstThumb.classList.add('active');
    if (firstMain) firstMain.classList.add('active');
  });

  // 弹窗变体切换改变价格、加购 + 自动匹配图片
  document.querySelectorAll('.acc-variant-item').forEach(item => {
    item.addEventListener('click', function () {
      const infoBox = this.closest('.acc-window-info-box');
      if (!infoBox) return;

      infoBox.querySelectorAll('.acc-variant-item').forEach(el => el.classList.remove('active'));
      this.classList.add('active');

      const variantId = this.id;
      const priceHtml = this.getAttribute('price');
      const isDisabled = this.classList.contains('disabled');

      const priceEl = infoBox.querySelector('.acc-window-price');
      if (priceEl) priceEl.innerHTML = priceHtml;

      const buyBtn = infoBox.querySelector('.acc-buy-btn');
      if (buyBtn) {
        buyBtn.setAttribute('data-variant-id', variantId);
        if (isDisabled) {
          buyBtn.textContent = 'Sold Out';
          buyBtn.classList.add('disabled');
        } else {
          buyBtn.textContent = 'Add to Cart';
          buyBtn.classList.remove('disabled');
        }
      }

      // ==============================================
      // 新增：根据 data-url 自动切换对应主图 + 缩略图（修复相对路径/https不匹配问题）
      // ==============================================
      const targetUrl = this.getAttribute('data-url');
      if (!targetUrl) return;

      const imgBox = infoBox.querySelector('.acc-window-img-box');
      if (!imgBox) return;

      const allMainImg = imgBox.querySelectorAll('.acc-main-img-item');
      const allThumbImg = imgBox.querySelectorAll('.acc-thumbs-img-item');

      // 先清空本组所有 active
      allMainImg.forEach(el => el.classList.remove('active'));
      allThumbImg.forEach(el => el.classList.remove('active'));

      // 工具函数：把任意路径（相对/绝对）转 URL 对象，方便拿pathname
      function getUrlPath(rawUrl) {
        try {
          // 如果是相对路径，用当前页面域名补全
          return new URL(rawUrl, window.location.origin).pathname;
        } catch (e) {
          return rawUrl;
        }
      }
      const targetPath = getUrlPath(targetUrl);

      // 匹配主图
      allMainImg.forEach(item => {
        const img = item.querySelector('img');
        if (!img) return;
        const imgPath = getUrlPath(img.src);
        // 只对比路径部分，忽略 http/https、域名
        if (imgPath === targetPath) {
          item.classList.add('active');
        }
      });

      // 匹配缩略图
      allThumbImg.forEach(item => {
        const img = item.querySelector('img');
        if (!img) return;
        const imgPath = getUrlPath(img.src);
        if (imgPath === targetPath) {
          item.classList.add('active');
        }
      });
    });
  });


  // 2. 数量加减 + 同步 data-quantity + 数量1时给减号加disable类
  document.addEventListener('click', function (e) {
    const isAdd = e.target.closest('.acc-add');
    const isMinus = e.target.closest('.acc-minus');
    if (!isAdd && !isMinus) return;

    const infoBox = (isAdd || isMinus).closest('.acc-window-info-box');
    if (!infoBox) return;

    const input = infoBox.querySelector('.acc-quantity-box');
    const minusBtn = infoBox.querySelector('.acc-minus');
    const buyBtn = infoBox.querySelector('.acc-buy-btn');
    if (!input || !buyBtn || !minusBtn) return;

    let val = parseInt(input.value, 10) || 1;

    if (isAdd) {
      val += 1;
    } else {
      val = Math.max(1, val - 1);
    }

    // 更新输入框
    input.value = val;
    // 同步数量到按钮
    buyBtn.setAttribute('data-quantity', val);

    // 数量为1时加 disable 类，否则移除
    if (val <= 1) {
      minusBtn.classList.add('disabled');
    } else {
      minusBtn.classList.remove('disabled');
    }

  });

  // 点击图片放大
  (function () {
    const modal = document.createElement('div');
    modal.className = 'img-preview-modal';
    document.body.appendChild(modal);

    const previewImg = document.createElement('img');
    modal.appendChild(previewImg);

    document.querySelectorAll('.acc-window-des img, .guidance-rule img').forEach(img => {
      img.style.cursor = 'zoom-in';

      img.addEventListener('click', function () {
        previewImg.src = this.src;
        modal.classList.add('show');
      });
    });

    // 3. 点击遮罩关闭
    modal.addEventListener('click', function () {
      modal.classList.remove('show');
    });
  })();


});



